// Vendors
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

// Components
import { TabDetail, Tabs } from 'components/Tabs'
import { TabPerformance } from '../tabs/TabPerformace'
import { TabCouponShow } from './tabs/TabCouponShow'

// Styles
import { Flex } from '@chakra-ui/react'

// Types
type CouponFormShowProps = {
  id: string
  endpoint: string
}

export const CouponFormShow = (props: CouponFormShowProps): JSX.Element => {
  /*
  |-----------------------------------------------------------------------------
  | Constants
  |-----------------------------------------------------------------------------
  |
  |
  */

  const { t } = useTranslation('common')
  const { id, endpoint } = props

  /*
  |-----------------------------------------------------------------------------
  | Memos
  |-----------------------------------------------------------------------------
  |
  |
  */

  const tabsDetails: TabDetail[] = useMemo(
    () => [
      {
        title: t('companies.tab_list.general'),
        component: TabCouponShow,
        options: { id, endpoint },
      },
      {
        title: t('companies.tab_list.performance'),
        component: TabPerformance,
      },
    ],
    [t, id, endpoint]
  )

  /*
  |-----------------------------------------------------------------------------
  | Renders
  |-----------------------------------------------------------------------------
  |
  |
  */

  return (
    <Flex h="full" flexDirection="column" justifyContent="space-between">
      <Tabs tabsDetails={tabsDetails} />
    </Flex>
  )
}
